import { render, staticRenderFns } from "./MyTasksIcon.vue?vue&type=template&id=384fe158&scoped=true"
import script from "./MyTasksIcon.vue?vue&type=script&lang=js"
export * from "./MyTasksIcon.vue?vue&type=script&lang=js"
import style0 from "./MyTasksIcon.vue?vue&type=style&index=0&id=384fe158&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fe158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384fe158')) {
      api.createRecord('384fe158', component.options)
    } else {
      api.reload('384fe158', component.options)
    }
    module.hot.accept("./MyTasksIcon.vue?vue&type=template&id=384fe158&scoped=true", function () {
      api.rerender('384fe158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/UIComponents/Tasks/MyTasksIcon.vue"
export default component.exports